import Address from './Address';
import BaseModel from './BaseModel';
import Project from './Project';
import Staff from './Staff';
import * as AT from '../../components/container/attributes';

export default class Poi extends BaseModel {
  constructor({
    id,
    designation,
    active = true,
    geometry = undefined,
    address = undefined,
    staff = undefined,
    project = undefined,
    creationDate = undefined,
    modificationDate = undefined,
    weight = undefined,
  }) {
    super(id, undefined, designation);
    this.active = active;
    this.geometry = geometry;
    this.address = address ? new Address(address) : null;
    this.staff = staff ? new Staff(staff) : null;
    this.project = project ? new Project(project) : null;
    this.creationDate = creationDate;
    this.modificationDate = modificationDate;
    this.weight = weight;
  }

  static get orderKey() {
    return 'designation';
  }

  get fullDesignation() {
    const linked = this.linkedEntityDesignation;
    if (linked && this.designation) {
      return `${linked} — ${this.designation}`;
    }
    return this.designation || linked || '';
  }

  get shortDesignation() {
    return this.designation;
  }

  /** Project, else staff, else address designation for browser labels. */
  get linkedEntityDesignation() {
    return (
      this.project?.fullDesignation ||
      this.staff?.fullDesignation ||
      this.address?.fullDesignation ||
      ''
    );
  }

  get fastModeBrowserDesignation() {
    return this.fullDesignation;
  }

  static get baseModuleForRedirection() {
    return 'project-base';
  }

  get baseModuleForRedirection() {
    return Poi.baseModuleForRedirection;
  }

  static get fkName() {
    return 'poi_id';
  }

  static get apiRoute() {
    return 'poi';
  }

  static get listPageRoute() {
    return undefined;
  }

  static get detailPageRoute() {
    return undefined;
  }

  get fkName() {
    return Poi.fkName;
  }

  get apiRoute() {
    return Poi.apiRoute;
  }

  get listPageRoute() {
    return Poi.listPageRoute;
  }

  get detailPageRoute() {
    return Poi.detailPageRoute;
  }

  static get joinAttrsKey() {
    return ['designation', 'active', 'address', 'staff', 'project', 'weight'];
  }

  static get listDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'active',
      'address',
      'staff',
      'project',
      'creationDate',
      'modificationDate',
      'weight',
    ]);
  }

  static get browserDisplayAttrs() {
    return this.getAttributes([
      'designation',
      'active',
      'address',
      'staff',
      'project',
      'weight',
    ]);
  }

  static get detailAttrs() {
    return this.allAttributes;
  }

  static get entityListDisplayAttrs() {
    return this.getAttributes(['designation', 'active']);
  }

  static get allAttributes() {
    return [
      this.DESIGNATION_ATTRIBUTE(),
      this.ACTIVE_ATTRIBUTE(),
      new AT.LocationAttribute({
        name: 'geometry',
        tableProperties: {
          header: 'hit-base.common.location',
        },
      }),
      new AT.FkAddressAttribute({
        name: 'address',
        column: 'address_id',
        joinPath: ['address!fk_poi_address_id_address'],
        fkToUpdate: 'address_id',
        tableProperties: {
          header: 'hit-base.common.address',
        },
        onlyFetchDesignation: true,
      }),
      new AT.FkStaffAttribute({
        name: 'staff',
        column: 'staff_id',
        joinPath: ['staff!fk_poi_staff_id_staff'],
        fkToUpdate: 'staff_id',
        tableProperties: {
          header: 'hit-base.common.staff',
        },
        onlyFetchDesignation: true,
      }),
      new AT.FkProjectAttribute({
        name: 'project',
        column: 'project_id',
        joinPath: ['project!fk_poi_project_id_project'],
        fkToUpdate: 'project_id',
        tableProperties: {
          header: 'hit-base.common.project',
        },
        onlyFetchDesignation: true,
      }),
      new AT.DateAttribute({
        name: 'creationDate',
        column: 'creation_date',
        tableProperties: {
          header: 'hit-base.common.creation-date',
          hideByDefault: true,
        },
      }),
      new AT.DateAttribute({
        name: 'modificationDate',
        column: 'modification_date',
        tableProperties: {
          header: 'hit-base.common.last-modified',
          hideByDefault: true,
        },
      }),
      new AT.IntegerAttribute({
        name: 'weight',
        column: 'weight',
      }),
    ];
  }
}
